export type ErrorMessageMap = Record<string, string>;

export function extractErrorCode(payload: any): string {
    if (!payload) return "";
    if (typeof payload?.error?.code === "string") return payload.error.code;
    if (typeof payload?.code === "string") return payload.code;
    if (typeof payload?.message === "string") return payload.message;
    if (Array.isArray(payload?.message) && payload.message.length > 0) {
        return String(payload.message[0]);
    }
    return "";
}

export function extractErrorFields(payload: any): string[] {
    if (!payload) return [];
    const fields = payload?.error?.fields ?? payload?.fields ?? [];
    if (Array.isArray(fields)) return fields.map((value) => String(value));
    if (fields != null) return [String(fields)];
    return [];
}

export function resolveErrorMessageKey(
    code: string | undefined,
    map: ErrorMessageMap,
    fallbackKey: string,
): string {
    const key = code ?? "";
    return map[key] ?? fallbackKey;
}
